import React, { useState, useEffect, useRef } from "react";

import "./Eyeq.css";
import { Scrollchor } from "react-scrollchor";
import Common_breadcrumb from "../common-components/common-breadcrumb/Common_breadcrumb";
import Form from "react-bootstrap/Form";
import Expert_eyes from "./expert-eyes/Expert_eyes";
import Performance from "./performance/Performance";
import Individual from "./individual/Individual";
import Visionary from "./visionary/Visionary";
import Sports from "./sports/Sports";
import { useDispatch, useSelector } from "react-redux";
import { getEyeq } from "../../features/bapateye/Slice";
import Common_title from "../common-components/common-title/Common_title";

const Eyeq = () => {
  const dispatch = useDispatch();

  const bapat_eyeq = useSelector((state) => state.bapateye.eyeqs);

  useEffect(() => {
    dispatch(getEyeq());
  }, []);

  const [selected, setSelected] = useState(null);

  // Reference for scrollable container
  const tabsRef = useRef(null);

 const handleClick = (value, index) => {
  setSelected(value);

  const target = document.getElementById(`sample-code${index + 1}`);

  if (tabsRef.current && target) {
    const containerTop = tabsRef.current.getBoundingClientRect().top;
    const targetTop = target.getBoundingClientRect().top;

    tabsRef.current.scrollTo({
      top: tabsRef.current.scrollTop + (targetTop - containerTop),
      behavior: "smooth",
    });
  }
};


  return (
    <>
      <section className="Eyeq_section">
        <Common_breadcrumb
          items={[{ label: "Home", link: "/" }, { label: "EyeQ" }]}
        />

        <div className="container-lg">
          {bapat_eyeq?.length > 0 ? (
            <div className="row">
              {/* LEFT RADIO LIST */}
              <div className="col-md-3 col-sm-4">
                <div className="alllistdiv">
                  <Form>
                    {bapat_eyeq?.map((item, index) => (
                      <Form.Check
                        key={item.id}
                        id={`item-${index}`}
                        type="radio"
                        label={item.name}
                        checked={selected === `item-${index}`}
                        onChange={() => handleClick(`item-${index}`, index)}
                      />
                    ))}
                  </Form>
                </div>
              </div>

              {/* RIGHT TABS AREA */}
              <div className="col-md-9 col-sm-8">
                <div className="tabsdatasec" ref={tabsRef}>
                  {bapat_eyeq?.map((item, index) => {
                    const titleParts = item.name.split(" ");
                    const title = titleParts[0];
                    const titleblack = titleParts.slice(1).join(" ");

                    return (
                      <div
                        className="tabdiv"
                        id={`sample-code${index + 1}`}
                        key={item.id}
                      >
                        <div className="radiotabsec">
                          <Common_title title={title} titleblack={titleblack} />

                          <div className="contsec">
                            <div className="row">
                              {index % 2 === 0 ? (
                                <>
                                  <div className="col-md-5 mb-md-0 mb-3">
                                    <div className="img_holder">
                                      <img
                                        className="eyeqban"
                                        src={
                                          process.env.REACT_APP_IMAGE_URL +
                                          item.image
                                        }
                                        alt="eyeq-img"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-7">
                                    <div className="contdiv">
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: item.description,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="col-md-7 mb-md-0 mb-3">
                                    <div className="contdiv">
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: item.description,
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-5">
                                    <div className="img_holder">
                                      <img
                                        className="eyeqban"
                                        src={
                                          process.env.REACT_APP_IMAGE_URL +
                                          item.image
                                        }
                                        alt="eyeq-img"
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                padding: "40px",
              }}
            >
              Data not available
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Eyeq;
